import { takeEvery, put, all } from 'redux-saga/effects';

import * as types from '../../actions/candidate/candidate-link-search-associates-account/types';
import * as actions from '../../actions/candidate/candidate-link-search-associates-account';

import httpStatusCodes from '../../constants/http-status-codes';
import handleError from '../../tools/error-helper';
import apiFetcher from '../../tools/api-fetcher';

function* linkSearchAssociatesAccount({ linkData }) {
  yield put(actions.setLoading(true));
  yield put(actions.setErrorMessage());

  try {
    yield apiFetcher
      .auth()
      .put(`candidates/current/link-search-associates-account`, linkData);
    yield put(actions.setSearchAssociatesAccountHasBeenLinked());
  } catch (exception) {
    switch (exception.response && exception.response.status) {
      case httpStatusCodes.Unauthorized:
        yield put(
          actions.setErrorMessage(
            'There is no active candidate account on Search Associates site with the provided credentials.'
          )
        );
        break;
      default:
        handleError(exception);
        break;
    }
  } finally {
    yield put(actions.setLoading(false));
  }
}

export default function* linkSearchAssociatesAccountSaga() {
  yield all([
    takeEvery(
      types.CANDIDATE_LINK_SEARCH_ASSOCIATES_ACCOUNT_LINK_ACCOUNT,
      linkSearchAssociatesAccount
    )
  ]);
}



// WEBPACK FOOTER //
// ./src/sagas/candidate/candidate-link-search-associates-account.js